import type React from 'react';

import { cn } from '@cobliteam/ui/utils';
import styles from './styles';

import { DescriptionTitle } from '@cobliteam/base-components';

interface CircleDividerProps {
  className?: string;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
const CircleDivider: React.FC<CircleDividerProps> = ({ className = '' }) => {
  return <DescriptionTitle className={cn(styles.divider, className)}>•</DescriptionTitle>;
};

export default CircleDivider;
